import * as React from "react";
const SvgFiRrAubergine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-aubergine_svg__a)">
      <path
        fill="#062147"
        d="M22.427 4.378q.59-.219 1.128-.546a1 1 0 0 0-1.1-1.668A6.5 6.5 0 0 1 20 2.931V1a1 1 0 1 0-2 0v1.931a6.5 6.5 0 0 1-2.451-.767 1 1 0 0 0-1.1 1.668q.538.327 1.128.546a4.97 4.97 0 0 0-1.534 2.994c-.524 2.77-3.486 2.6-6.388 2.63C-2.04 9.608-2.68 23.567 7 24c10.327 0 17-6.28 17-16a4.97 4.97 0 0 0-1.573-3.622M7 22c-7.021-.328-6.38-10.473.642-10 3.542.151 7.836-.36 8.38-4.38A3 3 0 0 1 18 5.178c.094.917-.436 2.767 1 2.822 1.434-.054.907-1.9 1-2.816A3 3 0 0 1 22 8c0 8.636-5.748 14-15 14"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-aubergine_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAubergine;
